import React, { useEffect, useState } from 'react';

import { Loader, Select, SelectProps, useMantineTheme } from '@mantine/core';
import { SelectItem } from '@mantine/core/lib/Select/types';
import { useDebouncedValue } from '@mantine/hooks';
import usePackageCategories from 'hooks/packageCategory/usePackageCategories';

interface IPackageCategorySelectProps extends Omit<SelectProps, 'data' | 'rightSection'> {
  value: string;
  packageCategoryId?: string;
}

const PackageCategorySelect = ({
  value,
  packageCategoryId,
  ...selectProps
}: IPackageCategorySelectProps): JSX.Element => {
  const theme = useMantineTheme();
  const [options, setOptions] = useState<SelectItem[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm] = useDebouncedValue(searchTerm, 250);
  const { data, isSuccess, isLoading } = usePackageCategories({
    search: debouncedSearchTerm,
  });

  useEffect(() => {
    if (isSuccess && data) {
      const categories = data.pages
        .flatMap(page => page.data.results)
        .filter(category => category.packageCategoryId !== packageCategoryId)
        .map(category => ({
          ...category,
          value: category.packageCategoryId,
          label: category.name,
        }));
      setOptions(categories);
    }
  }, [data, isSuccess, packageCategoryId]);

  return (
    <Select
      {...selectProps}
      data={options}
      searchable
      onSearchChange={setSearchTerm}
      nothingFound='Package Categories Not Found'
      maxDropdownHeight={100}
      rightSection={isLoading ? <Loader size={theme.fontSizes.md} /> : undefined}
      clearable
      value={value}
    />
  );
};

export default PackageCategorySelect;
